import { Platform } from "@angular/cdk/platform";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit
} from "@angular/core";
import { BehaviorSubject, of, Subject } from "rxjs";
import { filter, map, switchMap, takeUntil, tap } from "rxjs/operators";
import { ExtendedMediaStream } from "youm-lib";
import {
  ConferenceStream,
  LocalCamMicConferenceStream,
  LocalVideoConferenceStream
} from "youm-lib/conference";

@Component({
  selector: "app-video",
  templateUrl: "./video.component.html",
  styleUrls: ["video.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoComponent implements OnInit, OnDestroy {
  private readonly _stream$ = new BehaviorSubject<null | Stream>(null);
  private readonly _rawStream$ =
    new BehaviorSubject<null | ExtendedMediaStream>(null);
  private readonly _destroy$ = new Subject<void>();

  @Input() set stream(value: null | Stream) {
    this._stream$.next(value);
  }

  constructor(private readonly platform: Platform) {}

  ngOnInit() {
    this._stream$
      .pipe(
        filter((_): _ is Stream => !!_),
        switchMap((_) => ("stream$" in _ ? _.stream$ : of(_))),
        tap((_) => this._rawStream$.next(_)),
        takeUntil(this._destroy$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._stream$.complete();
    this._rawStream$.complete();

    this._destroy$.next();
    this._destroy$.complete();
  }

  get stream$() {
    return this._rawStream$.asObservable();
  }

  get isStreamShouldBeCanvased$() {
    return this._stream$.pipe(
      map((_) => (_ ? this._isStreamShouldBeCanvased(_) : false))
    );
  }

  private _isStreamShouldBeCanvased(stream: Stream) {
    if (!this.platform.SAFARI) {
      return false;
    }

    if (stream instanceof LocalVideoConferenceStream) {
      return true;
    }

    if (stream instanceof LocalCamMicConferenceStream && stream.isCanvased) {
      return true;
    }

    return false;
  }
}

type Stream = ExtendedMediaStream | ConferenceStream;
